// extracted by mini-css-extract-plugin
module.exports = {"cartFlex":"Style_cartFlex__2Mb73","text":"Style_text__2fi2b","taxText":"Style_taxText__2N6XO","proceed":"Style_proceed__IwWGo","boxContainer":"Style_boxContainer__3uLfl"};